import axios from 'axios'

import { attachPauth, generateLocalToken } from './authServie'
import { Constants } from '../utils/constants'

let SiteId = window?.Liferay?.ThemeDisplay?.getSiteGroupId()
let domainName = window.location.origin
let client_ID
let client_Secret
let token = window?.Liferay?.authToken
let isDevelopment
let currentDomain

;(async function setConstants () {
  currentDomain = window.location.origin
  isDevelopment = false

  switch (true) {
    case currentDomain.includes('dev'):
      client_ID = 'id-686b61b3-fe38-4395-8db6-c7d1f41a6ec1'
      client_Secret = 'secret-93dac2f3-548d-1685-198a-b838e4c1b2'
      break
    case currentDomain.includes('uat'):
      client_ID = 'id-76ed1921-26d2-207f-69ce-c818a427499a'
      client_Secret = 'secret-3b491320-f6be-4a92-1377-96ce7cd8ce'
      break
    case currentDomain.includes('prd'):
        case currentDomain.includes('hayak.dafz.ae'):
      client_ID = 'id-8ec85f81-1f9d-5b75-f840-aab1896def'
      client_Secret = 'secret-b3bb1294-ffc0-72f1-c628-c73bdd512d46'
      break
    case currentDomain.includes('localhost'):
      SiteId = '539712'
      client_ID = 'id-686b61b3-fe38-4395-8db6-c7d1f41a6ec1'
      client_Secret = 'secret-93dac2f3-548d-1685-198a-b838e4c1b2'
      isDevelopment = true
      currentDomain = 'https://hayak-dev.dafz.ae'
      break
    default:
      console.log('Unknown environment')
      break
  }
})()

const api = axios.create({
  baseURL: currentDomain,
  headers: { 'Access-Control-Allow-Origin': '*' }
})

// Add a request interceptor
api.interceptors.request.use(
  async function (config) {
    console.log("Request Interceptor Triggered");
    console.log("Original Request URL:", config.url);

    if (Constants.isDevelopment || config.url.includes("/reset-password")) {
      console.log("Development mode or reset-password endpoint detected");

      let token = await generateLocalToken();
      console.log("Generated Token:", token.access_token);

      config.headers.Authorization = 'Bearer ' + token.access_token;
      config.url = attachPauth(config.url);

      console.log("Updated Request URL (after attachPauth):", config.url);
      console.log("Authorization Header Set");
    } else {
      console.log("Production mode and non-reset-password endpoint");
      config.url = attachPauth(config.url);
      console.log("Updated Request URL (after attachPauth):", config.url);
    }

    return config;
  },
  function (error) {
    console.error("Request Interceptor Error:", error);
    return Promise.reject(error);
  }
);


// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)

export { api }
